var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-11 text-center apply-button"},[_c('p-button',_vm._g({staticStyle:{"padding-left":"65px","padding-right":"65px"},on:{"click":_vm.onApplyClicked}},_vm.$listeners),[_vm._v("\n    apply\n  ")]),_vm._v(" "),_c('a',{staticClass:"filter-cancel-text cursor-pointer align-middle",on:{"click":_vm.onCancel}},[_vm._v("CANCEL")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }